import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useNbrAuth } from "@/app/auth/useNbrAuth"
import { isNavItemActive } from "./navActiveMatchers"
import { NavAnimatedLink } from "./NavAnimatedLink"
import { buildSiteNavItems } from "./siteNav"

export type NavbarDesktopLinksProps = {
  headerTone: "transparent" | "solid"
  ariaLabel: string
  entranceClass?: string
}

export const NavbarDesktopLinks = ({ headerTone, ariaLabel, entranceClass = "" }: NavbarDesktopLinksProps) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const auth = useNbrAuth()
  const items = buildSiteNavItems(auth.isLibrarian)

  return (
    <div className={`hidden xl:flex flex-1 min-w-0 justify-center items-center px-2 ${entranceClass}`}>
      <nav className="flex items-center gap-0.5 min-w-0" aria-label={ariaLabel}>
        {items.map((item) => (
          <NavAnimatedLink
            key={item.key}
            to={item.to}
            label={t(`nav.${item.key}`)}
            isActive={isNavItemActive(item.key, pathname)}
            tone={headerTone === "transparent" ? "hero" : "solid"}
          />
        ))}
      </nav>
    </div>
  )
}
